import React, { useContext, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../css/Commission.css";
import "../../TabbedView/TabbedView.css";
import DeviceCode from "./DeviceCode";
import DeviceCodeReport from "./DeviceCodeReport";
import AcademicHeader from "../../AcademicHeader";
import SidebarContext from "../../sidebarcontext/SidebarContext";

export default function NewStudentAttendance() {
    const { AcademicYear, todayDate } = useContext(SidebarContext);

    const [activeTab, setActiveTab] = useState("report"); // More readable state

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
            />
            <div className="col-lg-12 col-md-12 col-sm-12 contentMainSection">
                <div className="row">
                    <div className="page-header">
                        <div className="text-start page-title">
                            {activeTab === "report"
                                ? "Student Attendance Report"
                                : "Device Code Management"}
                        </div>
                        <div className="page-date">
                            <div className="sec-content">
                                <AcademicHeader
                                    todayDate={todayDate}
                                    AcademicYear={AcademicYear}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <hr />

                <div className="tabview">
                    <div className="insidePopup--div">
                        <ul role="tablist" aria-label="Attendance Tabs">
                            <li
                                key="report-tab"
                                role="tab"
                                aria-selected={activeTab === "report"}
                                className={activeTab === "report" ? "active" : ""}
                                onClick={() => handleTabChange("report")}
                            >
                                <i className="fa fa-file-text-o mr-1 icon"></i>
                                Report
                            </li>
                            <li
                                key="device-code-tab"
                                role="tab"
                                aria-selected={activeTab === "deviceCode"}
                                className={activeTab === "deviceCode" ? "active" : ""}
                                onClick={() => handleTabChange("deviceCode")}
                            >
                                <i className="fa fa-qrcode mr-1 icon"></i>
                                Device Code
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="content-section main-content">
                    {activeTab === "report" && <DeviceCodeReport key="report-content" />}
                    {activeTab === "deviceCode" && <DeviceCode key="device-code-content" />}
                </div>
            </div>
        </>
    );
}